import React from 'react'
import PropTypes from 'prop-types'
import { Button, Classes, Dialog, MenuItem } from '@blueprintjs/core'
import { Select } from '@blueprintjs/select'

import { IN_PROGRESS, statusOptions } from 'src/store/modules/runbooks/actions'

class UpdateStatusDialog extends React.Component {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        onSelect: PropTypes.func.isRequired,
    }

    state = {
        selected: IN_PROGRESS,
    }

    statusRenderer = (item, { handleClick, modifiers }) => {
        const { byId } = statusOptions
        return (
            <MenuItem
                active={modifiers.active}
                key={item}
                onClick={handleClick}
                text={byId[item].value}
            />
        )
    }

    handleStatusChange = (item) => {
        this.setState({ selected: item })
    }

    render() {
        const { open, onClose, onSelect } = this.props

        return (
            <Dialog
                onClose={onClose}
                title="Bulk Update Status"
                isOpen={open}
                canOutsideClickClose={false}
            >
                <div className={Classes.DIALOG_BODY}>
                    <Select
                        items={statusOptions.ids}
                        itemRenderer={this.statusRenderer}
                        filterable={false}
                        popoverProps={{
                            minimal: true,
                            targetClassName: 'full-width',
                        }}
                        onItemSelect={this.handleStatusChange}
                    >
                        <Button
                            fill
                            text={statusOptions.byId[this.state.selected].value}
                            rightIcon="double-caret-vertical"
                        />
                    </Select>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            intent="primary"
                            large
                            onClick={() => {
                                onSelect(this.state.selected)
                            }}
                        >
                            Save
                        </Button>
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={this.props.onClose}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }
}

export default UpdateStatusDialog
